import axiosInstance from '../services/setup/axiosInstance';
import { showErrorToast } from '../services/setup/ApiResponseHandler';
import ErrorCodes from './ErrorCodes.json';

const errorMessage = (ERROR) => {
    let message =
        ERROR?.status === 500
            ? 'Internal Server Error'
            : ERROR?.data && ERROR?.data?.errorMessage
            ? ERROR.data.errorMessage
            : ErrorCodes[ERROR?.status];
    return message;
};

const HTTP_GET = async (url, params, config) => {
    try {
        return await axiosInstance
            .get(url, { params: params }, config)
            .then((response) => {
                return response;
            });
    } catch (error) {
        const ERROR = error.response;
        // showErrorToast(errorMessage(ERROR));
        return error.response;
    }
};

const HTTP_DELETE = async (url, data, config) => {
    try {
        return await axiosInstance
            .delete(url, { data: data }, config)
            .then((response) => {
                return response;
            });
    } catch (error) {
        const ERROR = error.response;
        showErrorToast(errorMessage(ERROR));
        return error.response;
    }
};

const HTTP_POST = async (url, payload, config, showError = true) => {
    try {
        return await axiosInstance
            .post(url, payload, config)
            .then((response) => {
                return response;
            });
    } catch (error) {
        const ERROR = error.response;
        if (showError) {
            showErrorToast(errorMessage(ERROR));
        }
        return error.response;
    }
};

const HTTP_PUT = async (url, payload, config, showError = true) => {
    try {
        return await axiosInstance
            .put(url, payload, config)
            .then((response) => {
                return response;
            });
    } catch (error) {
        const ERROR = error.response;
        if (showError) {
            showErrorToast(errorMessage(ERROR));
        }
        return error.response;
    }
};

export const RestServiceUtils = {
    HTTP_GET,
    HTTP_DELETE,
    HTTP_POST,
    HTTP_PUT,
};
